<template>
  <div
    v-if="!loggedIn || !hasDefaultSlot"
    class="container mx-auto py-8"
  >
    <BasicLogin
      :do-redirect="!hasDefaultSlot"
      @close-login="nav"
      @open-register="nav"
      @back-to-intro="nav"
      @navigate-modal="nav"
    />
    <LazyBasicModal
      v-if="dialog == 'PASSWORDRECOVER'"
      @close-modal="dialog = ''"
    >
      <BasicPasswordRecover
        @navigate-modal="nav"
        @back-to-login="dialog = ''"
      />
      <template #icon>
        <BasicIcon
          :name="'xmark-solid'"
          class="w-4 close-img"
        />
      </template>
    </LazyBasicModal>
  </div>
  <template v-else>
    <slot />
  </template>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue';
const slots = useSlots();
const hasDefaultSlot = computed(() => !!slots.default);
const dialog = ref('');
const { loggedIn: keycloakLoggedIn } = useOidcAuth();
const loggedIn = computed(() => useCurrentLoggedInState().value || keycloakLoggedIn);

function nav(dat: string) {
  if (dat == 'PASSWORDRECOVER') {
    dialog.value = 'PASSWORDRECOVER';
  } else if (dat == 'REGISTER') {
    return navigateTo('/registrieren');
  }
}
</script>
